import { parseISO, setHours, addDays, addWeeks, setDay, differenceInHours, getDay } from 'date-fns/fp';
import { DeliveryStatus } from '@calo/types';
class PermissionService {
    deliveryCanBeEdited(delivery, now = Date.now()) {
        return parseISO(delivery.day) > addDays(1)(now) &&
            delivery.status !== DeliveryStatus.paused;
    }
    deliveryAddressCanBeEdited(delivery, now = Date.now()) {
        return parseISO(delivery.day) > addDays(1)(now) &&
            delivery.status !== DeliveryStatus.paused;
    }
    getMinActionDate(deliveryDays, now, week = 0) {
        const lowerBorder = addDays(2)(now);
        if (deliveryDays.length === 0) {
            return lowerBorder;
        }
        const sorted = deliveryDays.sort();
        for (let day of sorted) {
            const startDay = addWeeks(week)(setDay(day)(now));
            if (startDay >= lowerBorder) {
                return startDay;
            }
        }
        return this.getMinActionDate(deliveryDays, now, week + 1);
    }
    getHoursTillSupension(plan, balance, deliveryDays, dayAllowance, now = Date.now()) {
        const pricePerDelivery = plan.pricePerDay;
        const initialDay = addDays(2)(now);
        let day = initialDay;
        while (balance + (dayAllowance * pricePerDelivery) > 0) {
            if (deliveryDays.includes(getDay(day))) {
                balance -= pricePerDelivery;
            }
            day = addDays(1)(day);
        }
        return differenceInHours(initialDay)(setHours(12)(day));
    }
    getApproxEndDate(plan, balance, deliveryDays, now = Date.now()) {
        const pricePerDelivery = plan.pricePerDay;
        let deliveries = Math.floor(balance / pricePerDelivery);
        let day = now;
        while (deliveries >= 0) {
            if (deliveryDays.includes(getDay(day))) {
                deliveries--;
                if (deliveries < 0) {
                    break;
                }
            }
            day = addDays(1)(day);
        }
        return day;
    }
}
export default new PermissionService();
